import { getListOfServiceRequest } from "../../../app/api/ServiceRequestDetails";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { ISaveServiceRequestResponse } from "../../../Orchestrator/Types/Interface/IServiceRequest";
import { IGetListOfServiceRequestActionParams, IServiceRequestTicketList } from "../../../Orchestrator/Types/Interface/IServiceRequestDetails";

class GetListOfServiceRequestAction extends BaseAction<IDefaultActionResult, IGetListOfServiceRequestActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            const { bookingId, screenFrom = "" } = this.params!
            const response = await getListOfServiceRequest(bookingId || "");
            let getAllServiceRequest: ISaveServiceRequestResponse[] = []            
            if (response.answer && response.status === "ok") {
                const srData: IServiceRequestTicketList = response.answer
                if (srData.content.length > 0) {
                    getAllServiceRequest = srData.content.filter(d => d.type === "SERVICE_REQUEST");
                    updateRecoilState("serviceRequestTicketListAtom", getAllServiceRequest)
                    if (getAllServiceRequest.length > 0 && screenFrom === "serviceRequestDetails") {
                        updateRecoilState("activeTicketAtom", getAllServiceRequest[0])
                    } else {
                        updateRecoilState("activeTicketAtom", null)
                    }
                } else {
                    updateRecoilState("serviceRequestTicketListAtom", [])
                }
                actionResult.data = getAllServiceRequest
                actionResult.status = "success"
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
            updateRecoilState("serviceRequestTicketListAtom", [])
        } finally {
            return actionResult
        }
    }
}

export const getListOfServiceRequestAction = new GetListOfServiceRequestAction();